
$(function() {
    $('#formChooseProduct').on('submit', function (e) {

        const $self = $(this);

        var preventSubmit = false;

        if ($self.hasClass('byemail')) {
            if (!validateChooseProductSubmitForByEmail($self)) {
                preventSubmit = true;
            }
        }

        if ($self.hasClass('bypost')) {
            if (!validateChooseProductSubmitForByPost($self)) {
                preventSubmit = true;
            }
        }

        if (preventSubmit) {
            e.preventDefault();
            window.snapToFirstInvalidElement();
        } else {
            $(this).find('[type="submit"]').prop('disabled', true);
        }
    });

    const $valueTextbox = $('#textboxGiftCardPriceX');

    toggleAddAnotherDisplayBasedOnSelectedValue($valueTextbox);

    $valueTextbox.on('change keyup', function () {
        toggleAddAnotherDisplayBasedOnSelectedValue($(this));
    });

    $valueTextbox.rules('add', {
        min: $valueTextbox.data('min-value'),
        max: $valueTextbox.data('max-value'),
        messages: {
            min: $valueTextbox.data('bad-amount-message'),
            max: $valueTextbox.data('bad-amount-message')
        }
    });

});

function validateChooseProductSubmitForByPost($form) {
    EnterAddressManually();

    if ($('#NameTitle').hasClass("is-invalid")) {
        $('.form-group.title .dropdown button').toggleClass("is-invalid");
    } else {
        $('.form-group.title .dropdown button').toggleClass("is-valid");

    }

    if ($('#GiftCardPriceX').val() === undefined || $('#GiftCardPriceX').val() === '') {
        $('#special-error').show();
        $('.gift-value-container  .dropdown button').toggleClass("is-invalid");

    } else {
        $('#special-error').hide();
        $('.gift-value-container  .dropdown button').toggleClass("is-valid");
    }

    return $form.valid();
}

function validateChooseProductSubmitForByEmail($form) {

    var isValid = true;

    if (!$form.valid()) {
        isValid = false;
    }

    if (!window.validateDeliveryDateForByEmail()) {
        isValid = false;
    }

    return isValid;
}

function toggleAddAnotherDisplayBasedOnSelectedValue($valueTextbox) {

    const current = parseInt($valueTextbox.val());
    const min = $valueTextbox.data('min-value');
    const maxOrder = $valueTextbox.data('max-order-value');
    const subtotal = $valueTextbox.data('current-subtotal');

    if ((current + subtotal + min) > maxOrder || (isNaN(current) && (min + min) > maxOrder)) {
        $('#btnProceedToPayment_AddAnother').hide();
    } else {
        $('#btnProceedToPayment_AddAnother').show();
    }
}